import { Skeleton } from 'antd';

import styles from './order-detail-skeleton.module.scss';

/** Shimmer placeholder that mirrors the Order Detail layout (header + Order Summary +
 *  Order Details/Logistics cards) while `useOrder` loads — replaces a bare spinner. */
export function OrderDetailSkeleton() {
  return (
    <div className={styles.page} aria-busy="true" aria-label="Loading order">
      <header className={styles.header}>
        <Skeleton.Input active size="large" style={{ width: 240 }} />
        <div className={styles.contacts}>
          <Skeleton.Input active size="small" style={{ width: 160 }} />
          <Skeleton.Input active size="small" style={{ width: 200 }} />
        </div>
      </header>

      <div className={styles.body}>
        <div className={styles.main}>
          <Skeleton.Input active size="small" style={{ width: 160 }} />
          {Array.from({ length: 3 }, (_, i) => (
            <div key={i} className={styles.lineItem}>
              <Skeleton.Avatar active shape="square" size={64} />
              <div className={styles.lineText}>
                <Skeleton.Input active size="small" block />
                <Skeleton.Input active size="small" style={{ width: '40%' }} />
              </div>
              <Skeleton.Input active size="small" style={{ width: 90 }} />
            </div>
          ))}
          <div className={styles.totals}>
            {Array.from({ length: 4 }, (_, i) => (
              <Skeleton.Input key={i} active size="small" block />
            ))}
          </div>
        </div>

        <aside className={styles.side}>
          {Array.from({ length: 2 }, (_, i) => (
            <div key={i} className={styles.card}>
              <Skeleton.Input active size="small" style={{ width: 140 }} />
              <Skeleton active title={false} paragraph={{ rows: 4 }} />
            </div>
          ))}
        </aside>
      </div>
    </div>
  );
}
